import { mapPriceField } from '@/shared/utils/priceFormatter';
import { normalizeProductPageUrl } from '@/features/pdp/utils/pdpUrl';
import type { SimilarDesignItem } from '../../domain/models/SimilarDesignItem';
import type {
  SimilarDesignItemDTO,
  SimilarDesignListEntryDTO,
  SimilarDesignsResponseDTO,
} from '../dto/similarDesigns.dto';

function adaptSimilarDesignItem(
  dto: SimilarDesignItemDTO,
  greyRender?: boolean
): SimilarDesignItem {
  return {
    designId: dto.designId ?? 0,
    designName: dto.designName ?? '',
    imageUrl: dto.imageUrl ?? '',
    customizationId: dto.customizationId,
    videoUrl: dto.videoUrl,
    videoPosterUrl: dto.videoPosterUrl,
    price: mapPriceField(dto.price),
    discountedPrice: mapPriceField(dto.discountedPrice),
    category: dto.category ?? '',
    productPageUrl: normalizeProductPageUrl(dto.productPageUrl),
    greyRender,
  };
}

function mapDesignItemList(entries: SimilarDesignListEntryDTO[]): SimilarDesignItem[] {
  return entries
    .filter((entry) => entry.designItem != null)
    .map((entry) => adaptSimilarDesignItem(entry.designItem!, entry.greyRender));
}

export function similarDesignsDtoToItems(dto: SimilarDesignsResponseDTO): SimilarDesignItem[] {
  const raw = dto.similarDesigns;
  if (!raw) return [];

  if (Array.isArray(raw)) {
    return raw.map((item) => adaptSimilarDesignItem(item));
  }

  return mapDesignItemList(raw.designItemList ?? []);
}
